/**
 * Code-level VOIP feature toggles.
 *
 * Developer-owned, baked into the bundle — NOT tenant / self-service configurable
 * (those flags live in `data/tenant-config.ts`). Consume via a direct import, matching
 * the `config/comparison.ts` pattern.
 */
export const VOIP_CONFIG: { loopbackVideo: boolean } = {
  /**
   * AVS-4302: when true, a standby dealer tab (a second tab of the same dealer, where
   * another tab owns the VOIP master slot) mirrors the master's published stream as a
   * loopback "You" tile. When false (default), the standby renders a dark placeholder
   * with a "Takeover" CTA instead of any loopback video.
   *
   * Typed `boolean` (not `as const`) so both branches stay live to the type checker.
   */
  loopbackVideo: false,
};
